import { render } from "./vl-calendar-month.vue?vue&type=template&id=a0b7c790"
import script from "./vl-calendar-month.vue?vue&type=script&lang=js"
export * from "./vl-calendar-month.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__